export default __webpack_public_path__ + "static/media/helmet.b7a26825.png";